import React from "react";
import NavPills from "components/NavPills/NavPills.jsx";
import Construction from "../../../components/Empty/Construction";

import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Code from "@material-ui/icons/Code";
import AccountBalanceWallet from "@material-ui/icons/AccountBalanceWallet";

import ViewContactsList from './Contacts/ViewContactList';

import { CircularProgress } from "@material-ui/core";

class Contacts extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    if(!this.props.contacts) {
      return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 150 }}>
        <CircularProgress color="secondary" />
      </div>
      );
    }

    console.log(this.props.contacts);

    return (
      <NavPills
        color="rose"
        horizontal={{
          tabsGrid: { xs: 12, sm: 12, md: 4 },
          contentGrid: { xs: 12, sm: 12, md: 8 }
        }}
        tabs={[
          {
            tabButton: "Business",
            tabIcon: AssignmentInd,
            tabContent: (
              <ViewContactsList {...this.props} contacts={this.props.contacts.filter(x => x.type === 'business')} type="business" />
            )
          },
          {
            tabButton: "Technical",
            tabIcon: Code,
            tabContent: (
              <ViewContactsList {...this.props} contacts={this.props.contacts.filter(x => x.type === 'technical')} type="technical" />
            )
          },
          {
            tabButton: "Financial",
            tabIcon: AccountBalanceWallet,
            tabContent: (
              <ViewContactsList {...this.props} contacts={this.props.contacts.filter(x => x.type === 'financial')} type="financial" />
            )
          }
        ]}
      />
    );
  }
}

export default Contacts;